import React, { useState } from "react";
import ReactECharts from "echarts-for-react";

import { useGetAllStats } from "@/api/Stat.api.ts";

const Analytics: React.FC = () => {
  const { data, isLoading, error } = useGetAllStats();
  const [count, setCount] = useState(0);

  if (isLoading) return <div>Loading...</div>;
  if (error) return <div>Error loading data</div>;

  const animalsPerBreed = (data && data?.animalsPerBreed) || [];

  const formattedData = animalsPerBreed
    .filter((item: any) => item && item._id && item.count)
    .map((item: any) => ({
      value: item.count,
      name: item._id,
    }));

  const option = {
    title: {
      text: "Animals Per Breed",
      subtext: "Analytics",
      x: "center",
    },
    tooltip: {
      trigger: "item",
      formatter: "{a} <br/>{b} : {c} ({d}%)",
    },
    legend: {
      orient: "horizontal",
      left: "right",
      top: "10%",

      data: formattedData.map((item: any) => item.name),
    },
    series: [
      {
        name: "Animals Per Breed",
        type: "pie",
        radius: "55%",
        top: ["50%"],
        center: ["50%", "60%"],
        data: formattedData,
        itemStyle: {
          emphasis: {
            shadowBlur: 10,
            shadowOffsetX: 0,
            shadowColor: "rgba(0, 0, 0, 0.5)",
          },
        },
      },
    ],
  };

  function onChartReady() {
    // console.log("echarts is ready", echarts);
  }

  function onChartClick() {
    // console.log(param, echarts);
    setCount(count + 1);
  }

  function onChartLegendSelectChanged() {
    // console.log(param, echarts);
  }

  return (
    <div className={"h-full"}>
      <ReactECharts
        option={option}
        style={{ height: 1000 }}
        onChartReady={onChartReady}
        onEvents={{
          click: onChartClick,
          legendselectchanged: onChartLegendSelectChanged,
        }}
      />
    </div>
  );
};

export default Analytics;
